import { memo, useMemo } from "react";
import { RouterProvider } from "react-router";

import { getRouter } from "@routes/router.tsx";
import { useRole } from "@stores/userStore";

import type { RouterProviderProps } from "react-router";

export const AppRouter = memo(function AppRouter(
  props: Omit<RouterProviderProps, "router">,
) {
  const role = useRole();

  const router = useMemo(() => {
    return getRouter(role);
  }, [role]);

  return <RouterProvider router={router} {...props} />;
});
